<!-- App.vue -->
<template>
  <div id="app">
    <!-- Chama o componente associado a rota (path) -->
    <router-view></router-view>
    <CookieConsent />
    <button
      v-if="ehCalculadora"
      type="button"
      class="botao-voltar-topo-global"
      aria-label="Voltar ao topo"
      title="Voltar ao topo"
      @click="voltarAoTopo"
    >
      <i class="bi bi-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
import CookieConsent from "@/components/CookieConsent.vue";

export default {
  name: "App",
  components: {
    CookieConsent,
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler(path) {
        const viewport = document.querySelector('meta[name="viewport"]');
        if (!viewport) return;

        const estaNoApp = path === "/app" || path.startsWith("/app/");
        viewport.setAttribute(
          "content",
          estaNoApp ? "width=768" : "width=device-width, initial-scale=1"
        );
      },
    },
  },
  computed: {
    ehCalculadora() {
      return this.$route.path.startsWith("/app/calculator-");
    },
  },
  methods: {
    voltarAoTopo() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style>
#app {
  font-family: 'Manrope', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.page-header {
  margin: 12px 0;
  padding: 12px 0;
}

.page-header-eyebrow {
  margin: 0 0 6px;
  color: #0056ff;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.breadcrumb-item.active {
  font-weight: 800;
}

.page-title,
.page-header h1,
.page-header h2,
.page-header h3,
.page-header h4,
#container > .row > .col-12 > h3,
#container > .row > .col-12 > h2 {
  margin-top: 0;
  margin-bottom: 0;
  color: #172033;
  font-weight: 800;
  font-size: clamp(1.25rem, 2vw, 1.65rem);
  line-height: 1.25;
}

.page-subtitle,
.page-header > p:not(.page-header-eyebrow),
.page-header + p,
#container > .row > .col-12 > h3 + p,
#container > .row > .col-12 > h2 + p {
  margin: 0;
  color: #596579 !important;
  font-size: 0.9rem;
  line-height: 1.5;
}

.calculadora-cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  margin: 24px 0;
  padding: 24px 0;
}

.breadcrumb-calculadora {
  margin: 0;
  flex: 0 0 auto;
}

.breadcrumb-calculadora .breadcrumb {
  margin: 0;
}

.badges-calculadora {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  white-space: nowrap;
}

.calculadora-resumo {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 220px;
  align-items: center;
  gap: 32px;
  margin: 40px 0 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e6ecf5;
}

.calculadora-resumo-sem-imagem {
  grid-template-columns: minmax(0, 1fr);
}

.calculadora-identificacao {
  min-width: 0;
}

.calculadora-identificacao .page-header-eyebrow {
  margin-bottom: 8px;
}

.calculadora-titulo {
  margin: 0;
  color: #172033;
  font-size: clamp(1.25rem, 2vw, 1.65rem);
  font-weight: 800;
  line-height: 1.15;
  overflow-wrap: anywhere;
}

.calculadora-subtitulo {
  margin: 12px 0 0;
  color: #596579;
  font-size: 0.95rem;
}

.calculadora-subtitulo strong {
  color: #34466b;
}

.calculadora-impressao {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #e6ecf5;
}

.calculadora-impressao h2 {
  margin: 0 0 8px;
  color: #172033;
  font-size: 1rem;
  font-weight: 700;
}

.calculadora-impressao p {
  margin: 0;
  color: #596579;
  font-size: 0.875rem;
  line-height: 1.55;
}

.calculadora-impressao .btn {
  min-width: 120px;
}

.calculadora-ilustracao {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 150px;
  margin: 0;
  padding: 16px;
  border: 1px solid #e6ecf5;
  border-radius: 8px;
  background: #f8fbff;
}

.calculadora-ilustracao figcaption {
  margin-top: 10px;
  color: #596579;
  font-size: 0.75rem;
}

.tab-pane h5.text-primary {
  margin-bottom: 1rem;
  padding: 8px 12px;
  border-left: 4px solid #0056ff;
  border-bottom: 1px solid #e6ecf5;
  color: #0056ff !important;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.calculator-drawing {
  margin-top: 32px;
  margin-bottom: 32px;
}

.calculator-drawing-title {
  margin: 0 0 16px;
  padding: 8px 12px;
  border-bottom: 1px solid #e6ecf5;
  border-left: 4px solid #0056ff;
  color: #0056ff;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  text-transform: uppercase;
}

.calculator-drawing-frame {
  display: flex;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.calculator-drawing-image {
  display: block;
  max-width: 70%;
  height: auto;
}

/* Padrao visual compartilhado pelas barras de acao das calculadoras. */
#container > .calculadora-resumo + .row.g-2.justify-content-end,
#container > .calculadora-resumo ~ .row.g-2.justify-content-end {
  position: relative;
  display: flex;
  justify-content: flex-end;
  width: max-content;
  max-width: 100%;
  margin-left: auto;
  gap: 8px;
  margin-top: 32px;
  margin-bottom: 32px;
  padding-top: 48px;
  border-top: 1px solid #e6ecf5;
}

#container > .calculadora-resumo + .row.g-2.justify-content-end {
  padding-top: 48px;
  padding-bottom: 24px;
  border-top: 1px solid #e6ecf5;
  border-bottom: none;
}

#container > .calculadora-resumo + .row.g-2.justify-content-end::before,
#container > .calculadora-resumo ~ .row.g-2.justify-content-end::before {
  content: "Ações do componente";
  position: absolute;
  right: 0;
  top: 12px;
  width: 100%;
  color: #172033;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
}

#container > .calculadora-resumo-sem-imagem ~ .row.g-2.justify-content-end {
  min-width: 180px;
}

#container > .calculadora-resumo-sem-imagem ~ .row.g-2.justify-content-end::before {
  white-space: nowrap;
}

#container > .calculadora-resumo + .row.g-2.justify-content-end > div,
#container > .calculadora-resumo ~ .row.g-2.justify-content-end > div,
.bocal-acoes > div {
  padding-right: 0;
  padding-left: 0;
}

.botao-voltar-topo-global {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1030;
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  color: #ffffff;
  background: #0056ff;
  box-shadow: 0 4px 12px rgba(23, 32, 51, 0.2);
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.botao-voltar-topo-global:hover {
  color: #ffffff;
  background: #0046d1;
  transform: translateY(-2px);
}

.botao-voltar-topo-global i {
  font-weight: 900;
  -webkit-text-stroke: 0.5px currentColor;
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .calculadora-cabecalho {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media (max-width: 700px) {
  .calculadora-cabecalho {
    align-items: flex-start;
    overflow-x: auto;
  }

  .calculadora-resumo {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-top: 28px;
  }

  .calculadora-ilustracao {
    min-height: 130px;
  }

  .calculadora-impressao {
    align-items: flex-start;
    flex-direction: column;
  }

  .calculadora-impressao .btn {
    width: 100%;
  }

  #container > .calculadora-resumo + .row.g-2.justify-content-end,
  #container > .calculadora-resumo ~ .row.g-2.justify-content-end {
    justify-content: center;
    width: 100%;
    margin-left: 0;
  }

  #container > .calculadora-resumo + .row.g-2.justify-content-end::before,
  #container > .calculadora-resumo ~ .row.g-2.justify-content-end::before {
    text-align: center;
  }

  .botao-voltar-topo-global {
    right: 16px;
    bottom: 16px;
  }
}

@media (max-width: 700px) {
  #container > nav.mt-3.mb-5 + .my-5.row > .col-md.text-start.text-md-end {
    position: static;
    width: 100%;
    margin-top: 16px !important;
    justify-content: flex-start;
    overflow-x: auto;
  }
}
</style>
